export default __webpack_public_path__ + "images/f1a05c1f9e40099da658cc3bee8781cd-market.png";